const preventDecimalInput = e => {
  if (e.key === '.' || e.key === ',') {
    e.preventDefault()
  }
}

export { preventDecimalInput }
